<template>
  <el-col class="displayLayout" id="orderManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单状态">
          <el-select v-model="formInline.orderStatusSeek" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="等待确认" value="0"></el-option>
            <el-option label="待支付" value="1"></el-option>
            <el-option label="支付成功" value="2"></el-option>
            <el-option label="待审核" value="13"></el-option>
            <el-option label="退款中" value="5"></el-option>
            <el-option label="退款成功" value="6"></el-option>
            <el-option label="退款失败" value="7"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="formInline.orderId" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="投保时间">
          <el-date-picker
            v-model="formInline.issueDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">搜索</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="orderId"
                         label="订单编号">
        </el-table-column>
        <el-table-column prop="sellProductName"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="issueDate"
                         width="160"
                         v-if="insuranceIsGroup != '5'"
                         label="投保日期">
        </el-table-column>
        <el-table-column prop="issueDate"
                         width="160"
                         v-if="insuranceIsGroup == '5'"
                         label="保障时间">
          <template slot-scope="scope">
            <span v-html="scope.row.beginTime"></span>
            <span> 至 </span>
            <span v-html="scope.row.endTime"></span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus"
                         label="订单状态">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="onSee(scope.row)">查看</el-button>
            <el-button size="mini" @click="onDelete(scope.row)"
                       v-if="('等待确认,待支付'.indexOf(scope.row.orderStatus.toString()) >= 0)">取消
            </el-button>
            <el-button size="mini" @click="onPay(scope.row)" v-if="scope.row.orderStatus === '待支付'">立刻支付</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getOrderList"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: "orderManagement",
    data() {
      return {
        loading: false,
        page: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        formInline: {
          orderId: '',
          orderStatusSeek: '',
          issueDate: '',
        },
        insuranceIsGroup: '4',
      }
    },
    watch: {
      '$route'() {
        this.getOrderList();
      }
    },
    methods: {
      /**
       * 查看
       * @param row
       */
      onSee(row) {
        let that = this,
          {orderToken, quoteIdNum} = row;

        if (that.insuranceIsGroup == '5'){
          that.$router.push({path: '/taiKang/orderDetail', query: {quoteIdNum}});
        }else {
          that.$router.push({name: 'orderDetails', query: {orderToken}});
        }
      },
      /**
       * 立刻支付
       * @param row
       */
      onPay(row) {
        let loadingInstance = this.Loading.service({fullscreen: true});
        let shareToken = this.$$.isValidObj(row.shareToken) ? row.shareToken : '';

        this.axios.post('/management/mobileInsuranceInfo/orderPaymentBefore?orderToken=' + encodeURIComponent(decodeURIComponent(row.orderToken)) + '&beShareToken=' + encodeURIComponent(decodeURIComponent(shareToken))).then((response) => {
          let data = response.data;
          if (data.success == true) {
            if (row.isEjsino) {
              let that = this;
              this.axios.post('/management/mobileInsuranceInfo/bindSellBillAtCostHandler?orderToken=' + encodeURIComponent(decodeURIComponent(row.orderToken))).then((response) => {
                const {success, msg, datas} = response.data;
                if (success && this.$$.isValidObj(datas)) {
                  const {payUrl} = datas;
                  window.open(payUrl, '_blank');
                } else {
                  if ("I0004" == msg) {
                    this.$$.alert({
                      message: "订单已经支付成功！", onOk: function () {
                        that.$router.push({name: 'employerOrderManagement'});
                      }
                    });
                    return;
                  }
                  this.$message.error(msg);
                }
                this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance.close();
                });
              });
            } else {
              let params = {
                orderToken: data.datas.orderToken,
                sellProductName: row.sellProductName
              };
              sessionStorage.setItem('orderPaymentParams', JSON.stringify(params));
              this.$router.push({name: 'orderPaymentType'});
            }
          } else {
            let msg = this.$$.constant.error_codes[data.msg];
            this.$message.info(this.$$.isValidObj(msg) ? msg : data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
      onDelete(row) {
        this.$confirm('是否取消此订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/management/mobileInsuranceInfo/getEndorOrOrderUpdate?orderToken='+encodeURIComponent(decodeURIComponent(row.orderToken))).then((response) => {
            if(response.data.success == true){
              this.$message.success('取消成功!');
              this.onSelect();
            }else{
              this.$message.info(response.data.msg);
            }
          });
        }).catch(() => {
          //this.$message.info('已取消删除');
        });
      },
      handleSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getOrderList();
      },
      onSelect() {
        this.page = 1;
        this.getOrderList();
      },
      getOrderList() {
        let insuranceIsGroup = this.$route.query.insuranceIsGroup;
        this.insuranceIsGroup = this.$$.isValidObj(insuranceIsGroup) ? insuranceIsGroup : '4';

        this.loading = true;
        if (!this.$$.isValidObj(this.formInline.issueDate)) this.formInline.issueDate = '';
        this.axios.post('/management/mobileOrderInfoLog/getOrderByUser', null, {
          params: {
            _pageSize: this.pageSize,
            _current: this.page,
            insuranceIsGroup: this.insuranceIsGroup,
            orderStatus: 3,
            orderStatusSeek: this.formInline.orderStatusSeek,
            orderId: this.formInline.orderId,
            issueDateBegin: this.formInline.issueDate[0],
            issueDateEnd: this.formInline.issueDate[1]
          }
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            let {list, pagination} = data.datas.list;

            this.tableData = list;
            this.page = pagination.current;
            this.total = pagination.total;
            this.loading = false;
          } else {
            this.$message.error(data.msg);
          }

          let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
          $('.el-table__body-wrapper').css('height', height);
        })
      }
    },
    mounted() {
      if (!this.$$.checkLogin()) return false;

      this.getOrderList();
    }
  }
</script>

<style scoped>
  @import "../../../../static/css/orderManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/orderManagement.vue